// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"6500adff","220":"c55ede58"}[chunkId] + ".chunk.js";
};